/* ===========================================================
   Jive PDP - shared behavior (gallery, drawer, accordions,
   faq, reviews carousel, sticky add-to-cart).
   Per-page option/price logic lives inline in each PDP.
   =========================================================== */
(function(){
  'use strict';

  // ----- mobile drawer -----
  var drawer = document.getElementById('drawer');
  var openD = document.getElementById('openDrawer');
  var closeD = document.getElementById('closeDrawer');
  if (drawer && openD) {
    // Keep the accessibility state in lockstep with the visual state. When closed the drawer is
    // translated off-screen but its links stay in the DOM, so it must be `inert` + aria-hidden
    // (otherwise keyboard/AT users land on invisible links). When open, expose it and move focus
    // in; on close, hand focus back to the hamburger. Markup ships closed (inert in the HTML).
    var setDrawer = function (open) {
      drawer.classList.toggle('open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) { drawer.removeAttribute('inert'); } else { drawer.setAttribute('inert', ''); }
      // Hide the floating chat bubble while the menu is open so it can't sit over the drawer
      // (CSS: html.jive-drawer-open hides the Chatwoot bubble/holder).
      document.documentElement.classList.toggle('jive-drawer-open', open);
    };
    openD.addEventListener('click', function () {
      setDrawer(true);
      var first = drawer.querySelector('nav a, #closeDrawer');
      if (first) first.focus();
    });
    if (closeD) closeD.addEventListener('click', function () { setDrawer(false); openD.focus(); });
    drawer.querySelectorAll('nav a').forEach(function (a) {
      a.addEventListener('click', function () { setDrawer(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) { setDrawer(false); openD.focus(); }
    });
  }

  // ----- PDP quick-link jump buttons -----
  // The .ql buttons use friendly hrefs (#nutrition, #ingredients, #reviews, #faq) that don't
  // match any element id. Map each to its real section and smooth-scroll (offset for the header).
  var QL_MAP = {
    nutrition: '.section-jive-nutrition-by-flavor, [id^="jive-nutrition"]',
    ingredients: '.jive-ingredients, [id^="jive-ingredients"]',
    reviews: '.jive-reviews-section, [id^="jive-reviews"]',
    faq: '.section-jive-faq, [id^="section-jive-faq"]'
  };
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a.ql[href^="#"]');
    if (!a) return;
    var sel = QL_MAP[a.getAttribute('href').slice(1)];
    if (!sel) return;
    var target = document.querySelector(sel);
    if (target) {
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 70;
      window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
    }
  });

  // ----- gallery thumbnails -----
  var mainImg = document.getElementById('galMainImg');
  var thumbs = document.getElementById('galThumbs');
  if (mainImg && thumbs) {
    thumbs.querySelectorAll('.gal-thumb').forEach(function(btn){
      btn.addEventListener('click', function(){
        var src = btn.getAttribute('data-src');
        if (!src) return; // image-slot placeholders have no src yet
        thumbs.querySelectorAll('.gal-thumb').forEach(function(b){ b.setAttribute('aria-selected','false'); });
        btn.setAttribute('aria-selected','true');
        mainImg.src = src;
      });
    });
  }

  // ----- accordions (buy box + faq share the pattern) -----
  function jiveAccSet(item, open){
    var ans = item.querySelector('.a');
    item.setAttribute('aria-expanded', open ? 'true' : 'false');
    var innerBtn = item.querySelector('button');
    if (innerBtn) innerBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (ans) ans.style.maxHeight = open ? (ans.scrollHeight + 'px') : '0px';
  }
  document.querySelectorAll('.acc-item, .faq-item').forEach(function(item){
    var btn = item.querySelector('button');
    var ans = item.querySelector('.a');
    if (!btn || !ans) return;
    if (item.getAttribute('aria-expanded') === 'true') { jiveAccSet(item, true); }
    btn.addEventListener('click', function(){
      var willOpen = item.getAttribute('aria-expanded') !== 'true';
      // Single-open: collapse the other open items in the same accordion group so only one
      // is open at a time. Group = nearest .acc/.faq container (falls back to document).
      var group = item.closest('.acc, .faq, [data-accordion]') || document;
      group.querySelectorAll('.acc-item[aria-expanded="true"], .faq-item[aria-expanded="true"]').forEach(function(other){
        if (other !== item) jiveAccSet(other, false);
      });
      jiveAccSet(item, willOpen);
    });
  });
  // recompute open accordion heights on resize (content reflows)
  window.addEventListener('resize', function(){
    document.querySelectorAll('.acc-item[aria-expanded="true"], .faq-item[aria-expanded="true"]').forEach(function(item){
      var ans = item.querySelector('.a');
      if (ans) ans.style.maxHeight = ans.scrollHeight + 'px';
    });
  });

  // ----- reviews carousel: 3 visible desktop, rest carouseled -----
  (function(){
    var track = document.getElementById('revTrack');
    var prev = document.getElementById('revPrev');
    var next = document.getElementById('revNext');
    var dotsWrap = document.getElementById('revDots');
    if (!track || !prev || !next || !dotsWrap) return;
    function pageCount(){ return Math.max(1, Math.round(track.scrollWidth / track.clientWidth)); }
    function currentPage(){ return Math.round(track.scrollLeft / track.clientWidth); }
    function buildDots(){
      dotsWrap.innerHTML = '';
      var n = pageCount();
      for (var i = 0; i < n; i++){ dotsWrap.appendChild(document.createElement('span')); }
      update();
    }
    function update(){
      var cur = currentPage();
      var dots = dotsWrap.children;
      for (var i = 0; i < dots.length; i++){ dots[i].classList.toggle('active', i === cur); }
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft > track.scrollWidth - track.clientWidth - 8;
    }
    prev.addEventListener('click', function(){ track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
    next.addEventListener('click', function(){ track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    track.addEventListener('scroll', function(){ window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', buildDots);
    buildDots();
  })();

  // ----- sticky add-to-cart: show after buy box scrolls past -----
  (function(){
    var sticky = document.getElementById('stickyCta');
    var anchor = document.querySelector('.kb') || document.querySelector('.buy');
    if (!sticky || !anchor) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(anchor);
    // tapping the sticky CTA jumps back up to the buy box so the user can complete their selection
    var scBtn = document.getElementById('scBtn');
    if (scBtn) scBtn.addEventListener('click', function(e){
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();
})();
